import { WATER_MAP_WATER_LAYERS, waterLayerTooBig, zoomInLayerMessage } from "./water_map_layer_policy"

export function waterLayerLoadPlan({ bounds, layerLimits = {}, enabled = {} } = {}) {
  const layers = WATER_MAP_WATER_LAYERS.map(key => {
    const on = enabled[key] !== false
    const zoomLimited = on && waterLayerTooBig(bounds, layerLimits, key)
    return {
      key,
      enabled: on,
      fetch: on && !zoomLimited,
      zoomLimited
    }
  })
  const zoomLimitedKeys = layers.filter(layer => layer.zoomLimited).map(layer => layer.key)
  return {
    layers,
    fetchKeys: layers.filter(layer => layer.fetch).map(layer => layer.key),
    zoomLimitedKeys,
    status: zoomInLayerMessage(zoomLimitedKeys)
  }
}

export function accessFeatureCounts(accesses = []) {
  return (accesses || []).reduce((counts, access) => {
    if (access.kind === "boat_ramp") counts.ramps += 1
    else counts.fishing += 1
    return counts
  }, { ramps: 0, fishing: 0 })
}

export function waterFeaturesStatus({ accesses = [], gauges = [] } = {}) {
  const counts = accessFeatureCounts(accesses)
  return `${counts.ramps} ramps · ${counts.fishing} fishing · ${(gauges || []).length} gauges`
}

export function fishLayerStatus({ waters = [], species = "" } = {}) {
  return `${(waters || []).length} waters with ${species}`
}
